import styled from 'styled-components';

export const TransferFromToWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
`;

export const SelectWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const SelectLabel = styled.label`
  font-size: 12px;
  color: ${(props) => props.theme.COLORS.textw};
  margin-bottom: 8px;
  align-self: flex-start;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
`;

export const StyledSelect = styled.select`
  width: 100%;
  height: 48px;
  background: ${({ theme }) => theme.COLORS.PrimaryInputBg};
  color: ${({ theme }) => theme.COLORS.textw};

  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;

  &:hover {
    border-color: rgba(0, 122, 255, 0.4);
    box-shadow: 0 4px 12px rgba(0, 122, 255, 0.2);
  }

  &:focus {
    border-color: #007aff;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.2);
    transform: translateY(-1px);
  }

  option {
    background-color: ${({ theme }) => theme.COLORS.InputBg};
    color: ${({ theme }) => theme.COLORS.textw};
    padding: 12px;
    font-weight: 500;

    &:hover {
      background-color: ${({ theme }) => theme.COLORS.InputBg};
    }
  }
`;

export const TransferCoinWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const TransferStaticInput = styled.div`
  width: 100%;
  background: ${(props) => props.theme.COLORS.bgColor};
  padding: 12px;
  border-radius: 7px;
  margin-top: 7px;
  display: flex;
  align-items: flex-start;
`;
export const TransferCoinListsWrapper = styled.div`
  position: absolute;
  width: 93%;
  top: 190px;
  left: 20px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 140px;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 999;
  border-radius: 5px;
  background-color: ${(props) => props.theme.COLORS.gray};
  box-shadow: 5px 5px 10px ${(props) => props.theme.COLORS.gray};
`;
export const TransferAmountWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
`;
export const TransferAmountAll = styled.div`
  position: absolute;
  right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const TransferCoinListItems = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-block: 15px;
  padding-inline: 20px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.COLORS.textsilver};
  }
`;
